import { render } from "./property-saleproceedsnew.vue?vue&type=template&id=1bfbd465"
import script from "./property-saleproceedsnew.js?vue&type=script&lang=js"
export * from "./property-saleproceedsnew.js?vue&type=script&lang=js"

import "./property-saleproceedsnew.vue?vue&type=style&index=0&id=1bfbd465&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__